<template>
  <!-- 这个是共识列表 -->
  <div class="projectManagement">
    <div class="title_box">
      <el-col :span="13">
        <h4>专家库列表</h4>
      </el-col>
      <!-- 左边的输入框 -->
      <div class="inputBox">
        <el-input
          :clearable="true"
          placeholder="请输入专家名称"
          v-model="input2"
          clearable
          @change="change"
        >
        </el-input>
        <el-button
          size="medium"
          style="background: #484c7f; color: #fff"
          @click="searchExpert"
        >搜索</el-button>
      </div>
      <!-- 搜索区域 -->
      <div class="searchBox">
        <!-- 右侧的按钮 -->
        <div class="buttonBox">
          <el-button
            size="medium"
            style="background: #258ce8; color: #fff"
            @click="experteditor"
          >录入专家</el-button>

          <el-button
            v-if="btnIsShow"
            size="medium"
            style="background: #6c757d; color: #fff"
            @click="backProject"
          >返回</el-button>
        </div>
      </div>
    </div>
    <!-- 卡片 -->
    <el-card class="box-card">
      <div
        class="box"
        ref="navigat"
      >
        <ul
          class="classfiy"
          ref="navigatUl"
        >
          <span>科室:</span>
          <li
            v-for="(item,index) in navigatList"
            :key="index"
            @click="navigatClick(index,item)"
            :class="item.id===navigatIndex?'active':'' "
          >{{item.name}}</li>
          <span
            v-if="navigatIcon"
            @click="pulldownClick"
            class="xila"
          ><i class="el-icon-arrow-down"></i></span>
          <span
            v-if="highPull"
            class="shang"
            @click="highPullClick"
          ><i class="el-icon-arrow-up"></i></span>
        </ul>
      </div>
    </el-card>
    <!-- 列表 -->
    <div
      class="expertList-box"
      v-if="expertObject.list!=0"
    >
      <ul class="expertList">
        <li
          @click="todetail(item)"
          v-for="(item,index) in expertObject.list"
          :key="index"
        >
          <div class="avater">
            <el-image :src="item.photo"></el-image>
          </div>
          <div class="h5-heda">{{item.name}}</div>
          <p class="discrib">{{item.hospital}}</p>
          <div class="tags">
            <el-tag
              class="tags-text"
              v-if="item.department_text"
              type="info"
              :hit="false"
              color="#EEE5FF"
            >{{item.department_text}}</el-tag>
            <el-tag
              class="tags-text"
              v-if="item.title"
              type="info"
              :hit="false"
              color="#EEE5FF"
            >{{item.title}}</el-tag>
          </div>
          <div class="delete">
            <div
              class="focus"
              @click.stop="expertCompile(item.id)"
              v-if="userinfo.userid==item.user_id"
            >
              <i class="iconfont icon-bianji1"></i>
              <p>编辑</p>
            </div>
            <!-- v-throttle="2000" -->
            <div
              class="focus"
              @click.stop="expertFollowClick(item)"
            >
              <div v-if="item.is_follow==0">
                <i class="iconfont icon-tianchongxing-"></i>
                <p>关注</p>
              </div>
              <div v-if="item.is_follow==1">
                <i class="iconfont icon-tianchongxing- quxiaoguanzhu"></i>
                <p>取消关注</p>
              </div>
            </div>

            <!-- 选择 -->
            <div v-if="selectIcon">
              <div
                @click.stop="selectClick(item.id)"
                v-throttle
                v-if="item.is_chooes==0"
                class="select-box"
              >
                <i class="select-img"> <img
                    src="../../assets/image/Select.png"></i>
                <p class="select-xq">选择</p>
              </div>

              <div
                @click.stop="cancellationSelectClick(item.id)"
                v-if="item.is_chooes==1"
                class="select-box"
              >
                <i class="select-img"> <img
                    src="../../assets/image/Cancellation_Select.png"
                  ></i>
                <p class="select-xq">取消选择</p>
              </div>
            </div>
            <!-- 选择 结束 -->

            <div
              class="focus remove"
              @click.stop="expertDelete(item.id)"
              v-if="userinfo.userid==item.user_id"
            >
              <i class="iconfont icon-shanchu2"></i>
              <p>删除</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div
      class="page"
      v-show="expertObject.list!=0"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-count="expertObject.pages"
        :current-page.sync="currentPage"
        hide-on-single-page
      >
      </el-pagination>
    </div>
    <div
      v-show="expertObject.list==0"
      class="available"
    >当前页面无数据</div>
    <!-- 分页 -->

  </div>
</template>

<script>
export default {
  name: 'ExpertDatabase',
  data () {
    return {
      userinfo: {},
      input2: '',
      // 是否弹出对话框 
      dialogVisible: false,
      navigatList: [],
      navigatIndex: 0,
      navigatIcon: true,
      highPull: false,
      //专家
      total: 0,//总条目数
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数  
      expertObject: {},
      selectIcon: false, //选择
      project_id: '',
      btnIsShow: false
    }
  },
  mounted () {
    this.getCateLlist()
  },
  //keep-alive 激活触发
  activated () {
    this.userinfo = JSON.parse(localStorage.getItem("userinfo"))
    if (this.$route.query.project_id != '' && this.$route.query.project_id != null && this.$route.query.project_id != undefined) {
      this.selectIcon = true
      this.btnIsShow = true
      this.project_id = this.$route.query.project_id
    }
    this.getExpertList()
  },
  //keep-alive 停用触发
  deactivated () {
    this.selectIcon = false
    this.btnIsShow = false
    this.project_id = ''
    this.navigatIndex = 0
    this.input2 = ''
    this.getExpertList()
  },
  watch: {
    //监听上拉
    highPull: {
      handler (newVal, oldVal) {
        this.$nextTick(function () {
          if (this.$refs.navigat.clientHeight > 100) this.highPull = true
        })
      },
      immediate: true,
    },
  },
  methods: {
    //点击导航 
    navigatClick (i, item) {
      this.navigatIndex = item.id
      setTimeout(() => {
        this.currentPage = 1
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //上拉
    highPullClick () {
      this.$nextTick(() => {
        if (this.$refs.navigat.clientHeight > 100) this.highPull = true
        this.$refs.navigat.style.height = `95px`
        this.navigatIcon = true
        this.highPull = false
      });
    },
    //点击导航下拉
    pulldownClick () {
      this.$nextTick(() => {
        this.$refs.navigat.style.height = `${this.$refs.navigatUl.clientHeight}px`
        this.navigatIcon = false
        this.highPull = true
      })
    },
    //决定导航是否下拉
    decidePulldown () {
      // this.$nextTick(() => {
      //   if (this.$refs.navigatUl.offsetHeight > 110) this.navigatIcon = true
      // }); 
      this.$nextTick(() => {
        if (this.$refs.navigat.offsetHeight < 110) {
          this.highPull = false
        }
        if (this.$refs.navigatUl.offsetHeight > 110) {
          this.navigatIcon = !this.highPull;
        }
        if (this.$refs.navigat.offsetHeight == 0) {
          this.highPull = true
        }
      });
    },
    //搜索
    searchExpert () {
      this.currentPage = 1
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    change (value) {
      this.input2 = value
      this.currentPage = 1
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    // 专家详情
    todetail (item) {
      this.$router.push({
        path: '/expertDetail', query: {
          id: item.id,
        }
      })
    },
    // 录入专家
    experteditor () {
      this.$router.push({
        path: '/expertEditor', query: {
          id: ""
        }
      })
    },
    //获取科室
    async getCateLlist () {
      const { data: data } = await this.$http.post("cate/list", {
        type: '1'
      })
      let arr = []
      arr.push({
        id: 0,
        name: '全部',
      }, ...data.data)
      this.navigatList = arr
      setTimeout(() => {
        this.decidePulldown()
      }, 200);
    },
    //获取专家列表
    async getExpertList () {
      const { data: data } = await this.$http.post("info/list", {
        type: 'expert', //专家
        limit: this.pagesize,//每页条数 
        page: this.currentPage,//第几页
        cate_id: this.navigatIndex, //科室
        name: this.input2,  //搜索 
        project_id: this.project_id  //选择信息库传入的
      })
      this.expertObject = data.data
      this.$Spin.hide();
    },
    //编辑
    expertCompile (item) {
      this.$router.push({
        path: '/expertEditor', query: {
          id: item,
          type: 'expert'
        }
      })
    },
    //关注 取消关注 点击
    expertFollowClick (item) {
      let status = 0
      if (item.is_follow == 0) { status = 1 }
      if (item.is_follow == 1) { status = 0 }
      if (status == 0) {
        this.$confirm('您是否要取消关注？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.getuserFollow(item, status)
        })
      } else {
        this.getuserFollow(item.id, status)
      }
    },
    //关注 取消关注 接口 
    async getuserFollow (info_id, status) {
      const { data: data } = await this.$http.post("user/follow", {
        info_id,
        type_id: 1,
        status
      })
      this.getExpertList()
      this.$message({
        message: data.message,
        type: 'success'
      });
    },
    //选择
    async selectClick (id) {
      const { data: data } = await this.$http.post("project/perfect", {
        project_id: this.project_id,
        type: 'expert_id',
        id: id
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.getExpertList()
    },
    //取消选择
    async cancellationSelectClick (id) {
      this.$confirm('您是否要取消选择?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post("project/delete", {
          type: 'expert_id',
          id,
          project_id: this.project_id,
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getExpertList()
      }).catch(() => { })
    },
    //删除   
    expertDelete (id) {
      this.$confirm('您是否要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post("info/del", {
          type: 'expert',
          id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getExpertList()
      }).catch(() => { })
    },
    //点击每一页 
    currentchange (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //下一页
    nextClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //返回
    backProject () {
      this.$router.back()
    }
  }
}
</script>

<style lang='less' scoped>
.projectManagement {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .title_box {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
    .inputBox {
      flex: 1;
      display: flex;
      margin-right: 56px;
      .el-input {
        flex: 1;
        margin-right: 16px;
      }
      .setDateTitle {
        margin-right: 14px;
        color: #8588ae;
        font-size: 18px;
      }
    }
  }

  /deep/ .el-card__body {
    padding: 10px;
  }
  .el-card {
    .box {
      position: relative;
      height: 95px;
      overflow: hidden;
      transition: all 0.3s;
      .classfiy {
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        span {
          color: #212529;
          font-size: 16px;
          line-height: 35px;
          // padding-right: 20px;
          margin: 7px 20px;
        }
        li {
          font-size: 16px;
          color: #212529;
          margin-right: 30px;
          padding: 0 11px;
          margin: 7px;
          line-height: 35px;
          cursor: pointer;
          transition: all 0.3s;
        }
        .active {
          border-radius: 4px;
          background: #484c7f;
          color: #fff;
        }
        .xila {
          position: absolute;
          bottom: 0px;
          right: -22px;
          font-size: 22px;
          cursor: pointer;
          z-index: 999;
          background-color: #fff;
          &:hover {
            color: #484c7f;
          }
        }
        .shang {
          position: absolute;
          bottom: 0px;
          right: -22px;
          cursor: pointer;
          font-size: 22px !important;
          &:hover {
            color: #484c7f;
          }
        }
        // .xila {
        //   position: absolute;
        //   bottom: -3px;
        //   right: -12px;
        //   font-size: 22px;
        //   cursor: pointer;
        //   z-index: 999;
        //   background-color: #fff;
        //   &:hover {
        //     color: #484c7f;
        //   }
        // }
        // .shang {
        //   position: absolute;
        //   bottom: -3px;
        //   right: -12px;
        //   cursor: pointer;
        //   font-size: 22px !important;
        //   &:hover {
        //     color: #484c7f;
        //   }
        // }
      }
    }
  }
  .expertList-box {
    min-height: 525px;

    .expertList {
      width: 100%;
      height: 100%;
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;

      li {
        width: 23.5%;
        text-align: center;
        margin-right: 2%;
        background: #fff;
        overflow: hidden;
        margin-top: 30px;
        padding-bottom: 10px;
        background: rgba(255, 255, 255, 0.39);
        border: 1px solid #f0f0f0;
        cursor: pointer;
        transition: 0.3s all;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:hover {
          transform: translate3d(0, -4px, 0);
        }
        .delete {
          text-align: center;
          margin-top: 10px;
          display: flex;
          justify-content: center;
          .focus {
            margin: 0 10px;
            i {
              font-size: 20px;
              color: #0d6efd;
            }
            p {
              font-size: 11px;
              color: #212529;
            }
          }
          .remove {
            i {
              color: #f7b52c;
            }
          }
          .quxiaoguanzhu {
            color: #aaaaaa !important;
          }
          .select-img {
            display: flex;
            width: 17px;
            height: 17px;
            margin: 6px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .avater {
          width: 109px;
          height: 109px;
          margin: 0 auto;
          margin-top: 20px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid #f0f0f0;
          img {
            width: 100%;
            height: 100%;
          }
          /deep/.el-image {
            width: 100%;
            height: 100%;
          }
        }
        h4 {
          color: #212529;
          font-size: 16px;
          margin-top: 10px;
        }
        .h5-heda {
          color: #212529;
          font-size: 16px;
          width: 200px;
          margin: 0 auto;
          margin-top: 13px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .discrib {
          color: #212529;
          font-size: 14px;
          margin-top: 10px;
          width: 200px;
          margin: 0 auto;
          padding-top: 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .tags {
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          .tags-text {
            width: 70px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          :nth-child(2) {
            margin-left: 10px;
          }
          .tags-follow {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 0 0 10px 25px;
            .tags-follow-img {
              width: 24px;
              height: 24px;
              margin-top: 3px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
  .page {
    margin-top: 30px;
    text-align: right;
  }
  .available {
    color: #8588ae;
    margin: 0 auto;
    padding-top: 320px;
  }
  // .delete {
  //   text-align: center;
  //   margin-bottom: 10px;
  //   margin-left: 20px;
  //   i {
  //     font-size: 22px;
  //     color: #f12937;
  //   }
  //   p {
  //     font-size: 11px;
  //     color: #212529;
  //   }
  // }
  .select-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .select-xq {
      font-size: 11px;
      color: #212529;
      padding-top: 1.8px;
    }
  }
}
</style>
